import { render } from "./item_description.vue?vue&type=template&id=5b6887f5"
import script from "./item_description.vue?vue&type=script&lang=js"
export * from "./item_description.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__